/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BusinessProfile =
  | 'BUYER'
  | 'SUPPLIER';

export type DeleteDocumentByIdFromOrderMutationVariables = Exact<{
  documentId: string;
  userBusinessProfile: Types.BusinessProfile;
}>;


export type DeleteDocumentByIdFromOrderMutation = { deleteDocumentByIdFromOrder: { success: boolean } | null };


export const DeleteDocumentByIdFromOrderDocument = /*#__PURE__*/ gql`
    mutation DeleteDocumentByIdFromOrder($documentId: uuid!, $userBusinessProfile: BusinessProfile!) {
  deleteDocumentByIdFromOrder(
    documentId: $documentId
    userBusinessProfile: $userBusinessProfile
  ) {
    success
  }
}
    `;
export type DeleteDocumentByIdFromOrderMutationFn = Apollo.MutationFunction<DeleteDocumentByIdFromOrderMutation, DeleteDocumentByIdFromOrderMutationVariables>;

/**
 * __useDeleteDocumentByIdFromOrderMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentByIdFromOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentByIdFromOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentByIdFromOrderMutation, { data, loading, error }] = useDeleteDocumentByIdFromOrderMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      userBusinessProfile: // value for 'userBusinessProfile'
 *   },
 * });
 */
export function useDeleteDocumentByIdFromOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentByIdFromOrderMutation, DeleteDocumentByIdFromOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentByIdFromOrderMutation, DeleteDocumentByIdFromOrderMutationVariables>(DeleteDocumentByIdFromOrderDocument, options);
      }
export type DeleteDocumentByIdFromOrderMutationHookResult = ReturnType<typeof useDeleteDocumentByIdFromOrderMutation>;
export type DeleteDocumentByIdFromOrderMutationResult = Apollo.MutationResult<DeleteDocumentByIdFromOrderMutation>;
export type DeleteDocumentByIdFromOrderMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentByIdFromOrderMutation, DeleteDocumentByIdFromOrderMutationVariables>;